import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import { 
  FaLock, FaUser, FaSignInAlt, FaEye, FaEyeSlash,
  FaGlobe, FaHotel, FaPlane, FaUmbrellaBeach 
} from 'react-icons/fa';

export default function Main() {
  const [pass, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const access = JSON.parse(localStorage.getItem("admin"))
    if(access != null) {
      window.location.replace("/main");
    }
  }, []);

  const login = async () => {
    if(username.length < 4 || pass.length < 4) {
      setErrorMessage("Enter correct username and password!");
      return;
    }

    setIsLoading(true);
    setErrorMessage('');

    const data = new FormData();
    data.append('email', username);
    data.append('pass', pass);

    try {
      const response = await axios({
        method: 'post',
        url: '/api/user/login.php',
        data: data,
        headers: {'Content-Type': 'multipart/form-data'},
      });

      if(response.data[0].msg === "disable") {
        setErrorMessage("Your account has been disabled. Please contact administrator.");
      } else if(response.data[0].msg == "fail") {
        setErrorMessage("Invalid credentials. Please try again!");
      } else {
        localStorage.setItem('admin', JSON.stringify(response.data));
        window.location.replace("/main");
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage("Network error. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      login();
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(135deg, #ebeeeeff 20%, #059e98 50%, #ca964c 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      overflow: 'hidden'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '1200px',
        height: '100%',
        maxHeight: '700px',
        background: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '24px',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        display: 'flex'
      }}>
        
        {/* Left Side - Brand & Info */}
        <div style={{
          flex: 1,
          background: 'linear-gradient(135deg, #059e98 0%, #0FA5A0 100%)',
          padding: '40px 30px',
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Background Pattern */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            zIndex: 0
          }}></div>
          
          <div style={{ 
            position: 'relative', 
            zIndex: 1,
            maxHeight: '100%',
            overflowY: 'auto',
            paddingRight: '10px'
          }}>
            {/* Custom scrollbar */}
            <style>{`
              ::-webkit-scrollbar {
                width: 4px;
              }
              ::-webkit-scrollbar-track {
                background: rgba(255, 255, 255, 0.1);
                border-radius: 2px;
              }
              ::-webkit-scrollbar-thumb {
                background: rgba(255, 255, 255, 0.3);
                border-radius: 2px;
              }
              ::-webkit-scrollbar-thumb:hover {
                background: rgba(255, 255, 255, 0.4);
              }
            `}</style>
            
            <div className="brand-logo" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              marginBottom: '30px'
            }}>
              <div style={{
                width: '50px',
                height: '50px',
                background: 'white',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#059e98',
                fontSize: '24px',
                fontWeight: 'bold',
                flexShrink: 0
              }}>
                TT
              </div>
             <div style={{ minWidth: 0 }}>
 <h1 style={{
    margin: 0,
    fontSize: 'clamp(24px, 2.5vw, 32px)',
    fontWeight: '800',
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    background: 'linear-gradient(90deg, #ffffff, #ca964c, #ffffff, #ffffff, #ffffff)',
    backgroundSize: '300% 100%',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    animation: 'brandGradient 5s ease-in-out infinite',
    fontFamily: "'Segoe UI', 'Roboto', sans-serif"
}}>
    Tawaf Travel
</h1>


{/* Add to your existing styles */}
<style>{`
  @keyframes brandGradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`}</style>
                <p style={{
                  margin: 0,
                  opacity: 0.9,
                  fontSize: 'clamp(12px, 1.2vw, 14px)',
                  fontWeight: '500',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>Premium Hajj & Umrah Services</p>
              </div>
            </div>

            <h2 style={{
              fontSize: 'clamp(20px, 2vw, 28px)',
              fontWeight: '700',
              marginBottom: '15px',
              lineHeight: 1.3
            }}>
              Welcome Back to Your Dashboard
            </h2>
            
            <p style={{
              fontSize: 'clamp(14px, 1.2vw, 16px)',
              opacity: 0.9,
              lineHeight: 1.6,
              marginBottom: '30px'
            }}>Manage your Tawaf Travel website effortlessly from one centralized dashboard. 
Create and publish blog content, optimize SEO pages, update hotel listings, and manage travel packages for Hajj and Umrah services.
            </p>

            <div className="features" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
              gap: '15px',
              marginBottom: '30px'
            }}>
              {[
                { icon: <FaHotel size={16} />, text: 'Hotel Management' },
                { icon: <FaPlane size={16} />, text: 'Travel Packages' },
                { icon: <FaGlobe size={16} />, text: 'SEO Management' },
                { icon: <FaUmbrellaBeach size={16} />, text: 'Blog Content' }
              ].map((feature, index) => (
                <div key={index} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  flexShrink: 0
                }}>
                  <div style={{
                    width: '28px',
                    height: '28px',
                    background: 'rgba(255, 255, 255, 0.2)',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    {feature.icon}
                  </div>
                  <span style={{
                    fontSize: 'clamp(12px, 1.1vw, 14px)',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="stats" style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '15px',
              borderTop: '1px solid rgba(255, 255, 255, 0.2)',
              paddingTop: '20px',
              flexWrap: 'wrap'
            }}>
              {[
                { value: '24/7', label: 'Support' },
                { value: '99.9%', label: 'Uptime' },
                { value: '256-bit', label: 'Encryption' }
              ].map((stat, index) => (
                <div key={index} style={{ textAlign: 'center', flex: 1, minWidth: '80px' }}>
                  <div style={{ 
                    fontSize: 'clamp(20px, 2vw, 28px)', 
                    fontWeight: '700',
                    lineHeight: 1
                  }}>
                    {stat.value}
                  </div>
                  <div style={{ 
                    fontSize: 'clamp(10px, 1vw, 12px)', 
                    opacity: 0.8,
                    marginTop: '5px'
                  }}>
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

     {/* Right Side - Login Form */}
<div style={{
  flex: 1,
  padding: '20px 30px', // Reduced top padding from 30px to 20px
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  overflow: 'auto' // Changed from 'hidden' to 'auto'
}}>
  <div style={{ 
    maxWidth: '400px', 
    margin: '0 auto', 
    width: '100%',
    paddingTop: '10px' // Add some top padding
  }}>
    {/* Logo Section - REMOVED NEGATIVE MARGINS */}
    <div style={{ 
      textAlign: 'center', 
      marginBottom: '25px',
      paddingTop: '0'
    }}>
      <img 
        src="/assets/img/logo1.png"
        alt="Tawaf Travel Logo" 
        style={{
          width: '250px', // Slightly smaller
          height: 'auto',
          maxWidth: '85%', 
          objectFit: 'contain',
          display: 'block',
          margin: '0 auto 15px auto', // No negative margins
        }}
        onError={(e) => {
          console.log('Trying alternative logo path...');
          e.target.src = '/img/logo1.png';
        }}
      />
      <div style={{ 
        marginTop: '25px', // Reduced distance
        paddingTop: '0'
      }}>
    <h2 style={{
  margin: '0 0 12px 0',
  fontSize: 'clamp(26px, 2.6vw, 34px)',
  fontWeight: '800',
  lineHeight: '1.1',
  letterSpacing: '0.8px',
  background: 'linear-gradient(90deg, #059e98, #0FA5A0, #ca964c, #E6B325, #059e98)',
  backgroundSize: '300% 100%',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  animation: 'flowingGradient 4s ease-in-out infinite',
  fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif"
}}>
  Admin Login
</h2>


{/* Add this animation to your styles */}
<style>{`
  @keyframes flowingGradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`}</style>
        <p style={{
          margin: '0',
          color: '#6b7280',
          fontSize: 'clamp(13px, 1.2vw, 15px)',
          lineHeight: '1.5',
          opacity: 0.9
        }}>
          Enter your credentials to access the dashboard
        </p>
      </div>
    </div>


            {errorMessage && (
              <div style={{
                background: '#fee2e2',
                border: '1px solid #fecaca',
                color: '#dc2626',
                padding: '12px 16px',
                borderRadius: '8px',
                marginBottom: '20px',
                fontSize: 'clamp(12px, 1.1vw, 14px)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <div style={{ fontSize: '16px' }}>⚠️</div>
                {errorMessage}
              </div>
            )}

            <div className="form-group" style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: '600',
                color: '#374151',
                fontSize: 'clamp(13px, 1.1vw, 14px)'
              }}>
                Username
              </label>
              <div style={{ position: 'relative' }}>
                <div style={{
                  position: 'absolute',
                  left: '16px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#9ca3af'
                }}>
                  <FaUser />
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(v) => { setUsername(v.target.value); setErrorMessage(''); }}
                  onKeyPress={handleKeyPress}
                  style={{
                    width: '100%',
                    padding: '12px 16px 12px 48px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: 'clamp(14px, 1.2vw, 16px)',
                    transition: 'all 0.3s',
                    outline: 'none',
                    backgroundColor: 'white'
                  }}
                />
              </div>
            </div>

            <div className="form-group" style={{ marginBottom: '25px' }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px'
              }}>
                <label style={{
                  fontWeight: '600',
                  color: '#374151',
                  fontSize: 'clamp(13px, 1.1vw, 14px)'
                }}>
                  Password
                </label>
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#059e98',
                    fontSize: 'clamp(11px, 1vw, 12px)',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    padding: '4px 8px'
                  }}
                >
                  {showPassword ? <FaEyeSlash size={12} /> : <FaEye size={12} />}
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
              <div style={{ position: 'relative' }}>
                <div style={{
                  position: 'absolute',
                  left: '16px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#9ca3af'
                }}>
                  <FaLock />
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter your password"
                  value={pass}
                  onChange={(v) => { setPassword(v.target.value); setErrorMessage(''); }}
                  onKeyPress={handleKeyPress}
                  style={{
                    width: '100%',
                    padding: '12px 48px 12px 48px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: 'clamp(14px, 1.2vw, 16px)',
                    transition: 'all 0.3s',
                    outline: 'none',
                    backgroundColor: 'white'
                  }}
                />
              </div>
            </div>

            <button
              onClick={login}
              disabled={isLoading}
              style={{
                width: '100%',
                padding: '14px',
                background: 'linear-gradient(135deg, #059e98 0%, #0FA5A0 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: 'clamp(14px, 1.2vw, 16px)',
                fontWeight: '600',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                opacity: isLoading ? 0.7 : 1
              }}
              onMouseEnter={(e) => {
                if (!isLoading) {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 10px 25px rgba(5, 158, 152, 0.3)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isLoading) {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }
              }}
            >
              {isLoading ? (
                <>
                  <div style={{
                    width: '18px',
                    height: '18px',
                    border: '2px solid rgba(255,255,255,0.3)',
                    borderTopColor: 'white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                  Signing In...
                </>
              ) : (
                <>
                  <FaSignInAlt /> Sign In to Dashboard
                </>
              )}
            </button>

            <div style={{
              marginTop: '25px',
              paddingTop: '15px',
              borderTop: '1px solid #e5e7eb',
              textAlign: 'center'
            }}>
              <p style={{
                margin: 0,
                color: '#6b7280',
                fontSize: 'clamp(10px, 1vw, 12px)',
                lineHeight: 1.5
              }}>
                For security purposes, this system is restricted to authorized personnel only.
                <br />
                All activities are monitored and logged.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Global Styles */}
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        
        input:focus {
          border-color: #059e98 !important;
          box-shadow: 0 0 0 3px rgba(5, 158, 152, 0.1) !important;
        }
        
        @media (max-width: 992px) {
          .login-wrapper {
            height: auto !important;
            max-height: 90vh !important;
            flex-direction: column !important;
          }
          
          .login-wrapper > div {
            flex: none !important;
            max-height: 50vh !important;
          }
          
          .login-wrapper > div:first-child {
            padding: 30px 20px !important;
          }
          
          .login-wrapper > div:last-child {
            padding: 30px 20px !important;
          }
        }
        
        @media (max-width: 768px) {
          body {
            padding: 10px !important;
          }
          
          .login-wrapper {
            max-height: 95vh !important;
            border-radius: 16px !important;
          }
          
          .features {
            grid-template-columns: 1fr !important;
          }
          
          .stats > div {
            min-width: 70px !important;
          }
        }
        
        @media (max-height: 600px) {
          .login-wrapper {
            max-height: 95vh !important;
            margin: 10px 0 !important;
          }
          
          .brand-logo {
            margin-bottom: 15px !important;
          }
          
          h2 {
            margin-bottom: 10px !important;
          }
          
          .features {
            margin-bottom: 20px !important;
          }
          
          .login-wrapper > div:first-child {
            padding: 20px 15px !important;
          }
          
          .login-wrapper > div:last-child {
            padding: 20px 15px !important;
          }
        }
      `}</style>
    </div>
  )
}